
























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LessonListDTO } from '../../../../src_server/entity/dto/LessonListDTO';
import BoardTeacherIcon from '../../../components/icon/BoardTeacherIcon.vue';
import UserIcon from '../../../components/icon/UserIcon.vue';
import WhiteBlackSquareButton from '../../../components/button/WhiteBlackSquareButton.vue';
import BookmarkIcon from '../../../components/icon/BookmarkIcon.vue';
import { MessageDialog } from '../../../utils/MessageDialog';
import { Session } from '../../../utils/Session';
import { emit } from 'cluster';

@Component({ components: { BoardTeacherIcon, WhiteBlackSquareButton, UserIcon, BookmarkIcon } })
export default class TeacherProfielCard extends Vue {
  @Prop({ default: new LessonListDTO() })
  dto!: LessonListDTO;

  @Prop({ default: false })
  favorite!: boolean;

  get favorite_title() {
    return this.favorite ? '解除' : 'お気に入りへ';
  }

  get nickname() {
    if (!this.dto?.teacher?.nickname) {
      return '';
    }
    return this.dto?.teacher.nickname;
  }
  get appeal() {
    if (!this.dto?.teacher?.appeal) {
      return '';
    }
    return this.dto.teacher.appeal;
  }

  get image() {
    if (this.dto?.teacher?.img_path) {
      return this.dto.teacher.img_path;
    } else {
      return '/assets/logos/default.png';
    }
  }
  showReservation() {
    if (!Session.isProfielComplete()) {
      MessageDialog.alertModal(`プロフィールを100%入力すると予約が実施できます。`);
      return;
    }
    this.$emit('click-reservation', this.dto);
  }
  showProf() {
    this.$emit('click-profiel', this.dto);
  }
  setFavorite() {
    this.$emit('click-favorite', this.dto);
  }

  showLessonMessageDialog() {
    this.$emit('lesson-message', this.dto.teacher?.user_id);
  }
}
